class CustomAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.accordionItems = Array.from(this.querySelectorAll('.accordion-item'));

    this.accordionItems.forEach((item) => {
      const accordionHeader = item.querySelector('.accordion-header');

      if (accordionHeader) {
        accordionHeader.addEventListener('click', () =>
          this.toggleAccordion(item),
        );
      }
    });
  }

  toggleAccordion(item) {
    const accordionContent = item.querySelector('.accordion-content');
    const header = item.querySelector('.accordion-header');

    if (!accordionContent || !header) return;

    const isOpen = item.classList.contains('open');

    if (this.dataset.singleOpen === 'true') {
      const accordions = document.querySelectorAll(
        "custom-accordion[data-single-open='true']",
      );

      accordions.forEach((accordion) => {
        const openItems = accordion.querySelectorAll('.accordion-item.open');

        openItems.forEach((otherItem) => {
          if (otherItem === item) return;

          otherItem.classList.remove('open');

          const otherContent = otherItem.querySelector('.accordion-content');

          if (otherContent) {
            otherContent.style.maxHeight = null;
          }
        });
      });
    }

    const willOpen = !isOpen;

    item.classList.toggle('open', willOpen);

    accordionContent.style.maxHeight = willOpen
      ? `${accordionContent.scrollHeight + 40}px`
      : null;

    if (willOpen && this.dataset.scrollAlign === 'true') {
      this.scrollToHeader(header);
    }
  }

  scrollToHeader(header) {
    const performScroll = () => {
      const rect = header.getBoundingClientRect();

      const scrollMarginTop = parseInt(
        window.getComputedStyle(header).scrollMarginTop || '0',
        10,
      );

      const targetTop = rect.top + window.scrollY - scrollMarginTop - 170;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth',
      });
    };

    const scrollDelayMs = 300;
    setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(performScroll);
      });
    }, scrollDelayMs);
  }
}

customElements.define('custom-accordion', CustomAccordion);
